
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 27 33","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.131 0c.874 0 1.716.347 2.327.974l7.97 7.97c.627.611.973 1.452.973 2.327V29.7a3.31 3.31 0 01-3.3 3.3H3.284C1.469 33 0 31.515 0 29.7L.017 3.3C.017 1.485 1.485 0 3.3 0zm-.28 2.475V9.9c0 .907.742 1.65 1.65 1.65h7.425L14.85 2.475z"}})])
          )
        }
      }
    